import axiosInstance from '../../../config/axiosInstance';
const  InvoiceService = {
    async GetAllInvoiceNotes(redirectCallback,InvoiceID) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
           const response = await axiosInstance.get(`/Invoice/GetInvoiceNotes?InvoiceID=${InvoiceID}`);
           return response.data;
        } catch (error) {
           console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteInvoiceNotes(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Invoice/DeleteInvoiceNotes?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default InvoiceService;